module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/sameer/Documents/projects/release/metabase/node_modules/babel-loader/lib/index.js??ref--0-0!/Users/sameer/Documents/projects/release/metabase/node_modules/eslint-loader/index.js??ref--1-0!/Users/sameer/Documents/projects/release/metabase/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/node_modules/promise-loader?global!./lib/ga-metadata.js
// module id = 414
// module chunks = 3 4 5